import { LogoBanner } from "./components/logo-banner";
import { HeroCards } from "./components/hero-cards/index";
import { Header } from "./components/header";
import { css } from "@compiled/react";

import UFOSegment from "@atlaskit/react-ufo/segment";

export const NoJiraHeroSection = () => {
    return (
        <UFOSegment name="logged-out-no-jira-product-tour-hero">
            <div css={heroStyles}>
                <Header />
                <HeroCards />
            </div>
            <LogoBanner />
        </UFOSegment>
    );
};

NoJiraHeroSection.displayName = "NoJiraHeroSection";

const heroStyles = css({
    // eslint-disable-next-line local/ensure-wac-token-usage
    background: "#F4F5F7",
    width: "100%"
});
